import React, { useState } from 'react';
import LazyImage from '../LazyImage';
import './Contact.css';
import girlImage from '../../assets/images/contact.webp';
import planeIcon from '../../assets/icons/plane.png';
import phone from '../../assets/icons/phone-circle.png';
import mail from '../../assets/icons/mail-circle.png';
import location from '../../assets/icons/location-circle.png';
import axios from 'axios';
import { ADMIN_EMAIL, EMAIL } from '../../Utils/EmailHelper';

const Contact = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        service: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        let dataAdmin = {
            "sender_email": EMAIL,
            "receiver_email": EMAIL,
            "subject": "New Service Request",
            "domain": "pfgs",
            "html_body": ADMIN_EMAIL(formData)
        }
        try {
            const responseAdmin = await axios.post('https://m52vkpoo46edzgvw3bkscwsfgq0xrxsm.lambda-url.us-east-1.on.aws', dataAdmin);
            if (responseAdmin.data.message === 'Email sent successfully.') {
                setResponseMessage(responseAdmin.data.message);
                setTimeout(() => {
                    setResponseMessage('');
                }, 5000);

            }
            setLoading(false)
        } catch (error) {
            setResponseMessage(
                error.response?.data?.message || 'Something went wrong. Please try again.'
            );
            setTimeout(() => {
                setResponseMessage('');
            }, 5000);
            setLoading(false)
        }

    };

    return (
        <section className="contact">
            <div className="container">
                <div className="contact-content">
                    <div className="contact-left">
                        <div className="contact-text">
                            <h2 className="contact-title">
                                We’re Here to Help <br /><span style={{ color: 'black', backgroundColor: 'var(--primary-color)' }}>Every Step of the Way</span>
                            </h2>
                            <p className="contact-description">
                                Whether you’re a business owner looking for strategic advice, need support with tax compliance, or want to discuss your superannuation needs—our team is ready to assist you. Reach out to schedule a consultation, ask a question, or simply say hello.
                            </p>
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                <img src={phone} width="42" alt="Plane icon" />
                                <span className="contact-point-text">(02) 9476 8531 | 0433 209 411</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                <img src={mail} width="42" alt="Plane icon" />
                                <span className="contact-point-text">mandeep@pfgs.com.au</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                <img src={location} width="42" alt="Plane icon" />
                                <span className="contact-point-text">G2/5 McGill Street, Lewisham NSW 2049</span>
                            </div>
                        </div>
                        <div className="contact-image contact-image-desktop">
                            <LazyImage src={girlImage} alt="Professional woman" />
                        </div>
                    </div>

                    <div className="contact-right">
                        <div className="contact-card">
                            <div className="card-header">
                                <h3 className="card-title" style={{ textAlign: 'center' }}>Let’s Talk</h3>
                                <p className="card-description">
                                    Fill out the form and our team will get back to you shortly.
                                </p>
                            </div>

                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="fullName" className="form-label">Full Name</label>
                                    <input
                                        type="text"
                                        id="fullName"
                                        name="fullName"
                                        className="form-input"
                                        placeholder="Enter your full name"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="form-input"
                                        placeholder="Enter your email address"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="phone" className="form-label">Phone Number</label>
                                    <input
                                        type="phone"
                                        id="phone"
                                        name="phone"
                                        className="form-input"
                                        placeholder="Enter your Phone Number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="service" className="form-label">Service</label>
                                    <select
                                        id="service"
                                        name="service"
                                        className="form-input form-select"
                                        value={formData.service}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select</option>
                                        <option value="Individual Tax Preparation">Individual Tax Preparation</option>
                                        <option value="Business Tax Services">Business Tax Services</option>
                                        <option value="Tax Planning">Tax Planning</option>
                                        <option value="Book keeping Services">Book keeping Services</option>
                                        <option value="Audit Support">Audit Support</option>
                                        <option value="Tax Consultation">Tax Consultation</option>
                                    </select>
                                </div>




                                <div className="form-group">
                                    <label htmlFor="message" className="form-label">Message</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        className="form-input form-textarea"
                                        placeholder="Enter your message here"
                                        rows="4"
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                {loading ? <span>Please wait....</span> : <button type="submit" className="submit-btn">
                                    <span>Send</span>
                                    <img src={planeIcon} alt="" className="btn-icon" />
                                </button>}

                                {responseMessage && <div className="response-message">{responseMessage}</div>}
                            </form>
                        </div>
                        <div className="contact-image contact-image-mobile">
                            <LazyImage src={girlImage} alt="Professional woman" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;